import {
  getTsdContactListData,
  getTsdContactListDataByTsdId,
  _getTCTDataById,
} from '../tsdContacts/mockData'
import { getTsdDocumentListDataByTsdId } from '../tsdDocuments/mockData'
import { getTsdNoteListDataByTsdId } from '../tsdNotes/mockData'
import { getTsdResourceListDataByTsdId } from '../tsdResources/mockData'
import { getTsdSupplierListDataByTsdId } from '../tsdSuppliers/mockData'
import { getTaskListDataByTsdId } from '../tasks/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { ITsd, ITsdOverview } from '@/types/tsd/models'
import type { TEntityId, ISelectItem } from '~/types/models'

const tsdListData = undefined as unknown as ITsd[]

export const getTsdListData = getListDataFunctionFactory<ITsd[]>({
  listData: tsdListData,
  storageKey: 'tsds',
  getStartingListData: getStartingTsdListData,
})

export function _getTDataById(id: TEntityId, list: ITsd[]): ITsd {
  if (!list) {
    throw new Error(`_getTDataById called with undefined/null list`)
  }
  const tsd = list.find((t: ITsd) => t.id === id)
  if (!tsd) {
    throw new Error(`Can't find tsd '${id}'`)
  }
  return tsd
}

export function _getTSelectItemDataById(
  id: TEntityId,
  list: ITsd[]
): ISelectItem {
  if (!list) {
    throw new Error(`_getTDataById called with undefined/null list`)
  }
  const tsdData = _getTDataById(id, list)
  if (!tsdData) {
    throw new Error(`Can't find tsd '${id}'`)
  }
  return { id: tsdData.id, label: tsdData.descr }
}

export async function getTsdData(id: TEntityId): Promise<ITsd | undefined> {
  const listData = await getTsdListData()
  return _getTDataById(id, listData)
}

export async function getTsdSelectData(id: TEntityId): Promise<ISelectItem> {
  const listData = await getTsdListData()
  if (!listData) {
    throw new Error(`getTsdSelectData returned undefined/null`)
  }
  return _getTSelectItemDataById(id, listData)
}

export async function getTsdOverviewData(
  id: string
): Promise<ITsdOverview | undefined> {
  const tsdData = await getTsdData(id)
  if (!tsdData) {
    return undefined
  }
  const overviewData = {
    tsd: tsdData,
    tsdSuppliers: (await getTsdSupplierListDataByTsdId(id)) || [],
    tsdContacts: (await getTsdContactListDataByTsdId(id)) || [],
    tsdDocuments: (await getTsdDocumentListDataByTsdId(id)) || [],
    tsdNotes: (await getTsdNoteListDataByTsdId(id)) || [],
    tsdResources: (await getTsdResourceListDataByTsdId(id)) || [],
    tasks: (await getTaskListDataByTsdId(id)) || [],
    opportunities: [],
    projects: [],
    orderServiceOrders: [],
    serviceRequests: [],
    cases: [],
    contracts: [],
  }
  console.debug(overviewData)
  return overviewData
}

export async function getStartingTsdListData(): Promise<ITsd[]> {
  const tctList = await getTsdContactListData()
  return [
    {
      id: 'XXT0001',
      hrid: 'T0001',
      descr: 'TBI',
      splitFraction: 0.85,
      spendAmount: 165000,
      numOpenOpportunities: 4,
      numSuppliers: 3,
      numOrders: 180,
      channelManager: _getTCTDataById('XXTCT0002', tctList),
      relationship: {
        id: 1,
        label: 'Direct',
      },
      lastActivityDate: '2022-03-01',
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXT0002',
      hrid: 'T0002',
      descr: 'Intelisys',
      splitFraction: 0.8,
      spendAmount: 94000,
      numOpenOpportunities: 7,
      numSuppliers: 2,
      numOrders: 43,
      channelManager: _getTCTDataById('XXTCT0001', tctList),
      relationship: {
        id: 1,
        label: 'Direct',
      },
      lastActivityDate: '2022-03-04',
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXT0003',
      hrid: 'T0003',
      descr: 'WXTG',
      splitFraction: 1.0,
      spendAmount: 124444,
      numOpenOpportunities: 10,
      numSuppliers: 1,
      numOrders: 220,
      channelManager: _getTCTDataById('XXTCT0003', tctList),
      relationship: {
        id: 2,
        label: 'House',
      },
      lastActivityDate: '2022-03-08',
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
